"use client";

import { useEffect } from "react";
import { useSession } from "next-auth/react";
import { usePathname, useRouter } from "@/i18n/navigation";

// Pages where a logged-in user without a phone is NOT forced to the setup page.
const EXEMPT = ["/setup-phone", "/login", "/register", "/verify"];

// Sends authenticated users who haven't added a phone number to /setup-phone.
export function PhoneGate() {
  const { data: session, status } = useSession();
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    if (status !== "authenticated" || !session?.user) return;
    if (session.user.phone) return;
    if (EXEMPT.some((p) => pathname.startsWith(p))) return;
    router.replace("/setup-phone");
  }, [status, session, pathname, router]);

  return null;
}
